module.exports = __webpack_public_path__ + "img/przedszkole1.00b76e52.jpg";